import React from "react";
import DOMPurify from "dompurify";
import useOpenDocument from "../../../../hooks/useOpenDocument";
import { useAutoAnimate } from "@formkit/auto-animate/react";
import { DateDisplay } from "../../../";
import { EmailAttachmentDocument } from "../../../emails/EmailAttachmentDocument";
import { EmailAttachmentGroup } from "../../../emails/EmailAttachmentGroup";
import { FiledEmailType } from "../../../../types/EmailType";

// TODO: want to display a few more components and features that tie in with how outlook displays stuff

export const FiledEmailDisplayCard = ({ data } : Readonly<{ data: FiledEmailType }>) : JSX.Element => {
    const { openDocument } = useOpenDocument();
    const [attachmentAnimation] = useAutoAnimate();
    const { 
        attachments,
        body, 
        receivedDate, 
        recipientEmails, 
        senderEmailAddress 
    } = data;
    
    const onOpenAttachment = (documentId: string, fileName: string) => openDocument(documentId, fileName);

    return (
        <div className="card">
            <div className="card-body">
                <div className="d-flex flex-row">
                    <div className="flex-fill text-truncate">
                        <span>From: </span>{senderEmailAddress}
                    </div>
                    {/* <div>
                        ...
                    </div> */}
                </div>
                <div className="d-flex flex-row">
                    <div className="flex-fill text-truncate">
                        <span className="me-1">To:</span>
                        {recipientEmails.map((el) => (
                            <span>{el}</span>
                        ))}
                    </div>
                    <div className="font-monospace">
                        <DateDisplay format="ddd DD/MM/YYYY h:mma">{receivedDate}</DateDisplay>
                    </div>
                </div>
                {attachments && attachments.length > 0 && (
                    <EmailAttachmentGroup ref={attachmentAnimation} className="my-3">
                        {attachments.map((el, i) => (
                            <EmailAttachmentDocument key={i} data={el} onClick={() => onOpenAttachment(el.documentId, el.fileName)} />
                        ))}
                    </EmailAttachmentGroup>
                )}
                <div id="email-body" className="my-3" dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(body) }} />
            </div>
        </div>
    );
};